import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import navigationRoutes from "@/utils/navigationRoutes";
import PTSNavigationRoutes from "@/project/PTS/utils/navigationRoutes";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

const ProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;
  const navigate = useNavigate();
  const location = useLocation();
  const hasNavigated = useRef(false); // to prevent double navigation

  const path = location.pathname;
  const inviteCode =
    new URLSearchParams(location.search).get("refer_code") ??
    path.match(/\/pts\/refer_code=([^/?#]+)/)?.[1] ??
    null;
  // PTS routes: /dashboard, /employee, etc. Main app: /login, /signup, /schemas, /tenant, etc.
  const mainAppPrefixes =
    /^\/(login|signup|forgot-password|schemas|tenant|from|tenant-profile|social-configuration|nps|import-management|letter-head|notification|print-format|workflow|translation|user-permissions|permission|role-list|email-configuration|sms-configuration)/;
  const isPTSRoute = path.includes("/pts") || !mainAppPrefixes.test(path);

  useEffect(() => {
    if (hasNavigated.current) {
      return;
    } // stop multiple redirects
    if (isAuthenticated || isLoggedIn) {
      return;
    }

    const handleNavigation = async () => {
      // If invite code detected → redirect to PTS login (at root) with refer_code
      if (inviteCode) {
        hasNavigated.current = true;
        navigate(
          `${PTSNavigationRoutes.ADMIN_LOGIN_PAGE}?refer_code=${inviteCode}`,
          { replace: true }
        );
      } else if (isPTSRoute) {
        navigate(PTSNavigationRoutes.ADMIN_LOGIN_PAGE, { replace: true });
      } else {
        navigate(navigationRoutes.LOGIN, { replace: true });
      }
    };

    handleNavigation();
  }, [isAuthenticated, isLoggedIn, inviteCode, isPTSRoute, navigate]);

  // If authenticated or logged in, render protected content
  if (isAuthenticated || isLoggedIn) {
    return <Outlet />;
  }

  // Return null while redirecting
  return null;
};

export default ProtectedRouter;
